import React from 'react';
import { Button, InputLabel, TextField, Grid } from '@material-ui/core';
import moment from 'moment';
import FormSection from '../../../components/atom/FormSection';
import DatePickerDropdown from '../../../components/atom/DatePickerDropdown';
import { doSwaggerCall } from '../../../hooks/useSwaggerClient';
import { useNotify } from '../../../hooks/useNotify';

export default function BookingItemCustomBookingSettings({
    values,
    setFieldValue,
    bookingCanModify
}) {
    const { notifySuccess, notifyError } = useNotify();

    const onCreate = () => {
        const customerId = values?.booking?.user?.id;

        if (!customerId) {
            notifyError('For custom bookings, you must select a Guest!');
            return;
        }
        doSwaggerCall('bookings', 'createCustomBooking', {
            data: {
                activityId: values.activity_id,
                customBookingData: {
                    // on create grab the original start date and end date
                    activity_start: values.activity_start,
                    activity_end: values.activity_end,
                    guest_id: customerId
                }
            }
        })
            .then(res => {
                setFieldValue('custom_booking', {
                    id: res.id,
                    activity_id: values.activity_id,
                    activity_start: res.activity_start,
                    activity_end: res.activity_end,
                    voucher_number: res.voucher_number
                });
                setFieldValue('custom_booking_id', res.id);
                notifySuccess('Custom booking created');
            })
            .catch(e => {
                console.log(e);
                notifyError(e?.response?.body?.message || 'Custom booking cannot be created!');
            });
    };

    return (
        <>
            <FormSection title="Custom booking">
                {!values.custom_booking ? (
                    <>
                        <Grid item xs={12}>
                            {values?.custom_booking_id === null ? (
                                <h5>
                                    Currently this is not custom booking, everything was managed by
                                    the system.
                                </h5>
                            ) : (
                                <h4>Custom booking</h4>
                            )}
                        </Grid>
                        {values?.custom_booking_id === null && bookingCanModify && (
                            <Grid item xs={12}>
                                <Button
                                    onClick={() => {
                                        onCreate();
                                    }}
                                >
                                    Turn into custom booking
                                </Button>
                            </Grid>
                        )}
                    </>
                ) : (
                    ''
                )}
                {values?.custom_booking_id && (
                    <>
                        <Grid item xs={6}>
                            <TextField
                                label="Voucher number"
                                disabled={!bookingCanModify}
                                fullWidth
                                required
                                type="text"
                                value={values.custom_booking?.voucher_number}
                                onChange={ev =>
                                    setFieldValue('custom_booking.voucher_number', ev.target.value)
                                }
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label="Vendor code"
                                disabled={!bookingCanModify}
                                fullWidth
                                required
                                type="text"
                                value={values.custom_booking?.vendor_code}
                                onChange={ev =>
                                    setFieldValue('custom_booking.vendor_code', ev.target.value)
                                }
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <div style={{ width: 260 }} className="golf-picker">
                                <InputLabel style={{ marginBottom: '3px' }} shrink>
                                    Activity Start Date & Time:
                                </InputLabel>
                                <DatePickerDropdown
                                    date={values.custom_booking?.activity_start}
                                    id="bookingPanelStartDate"
                                    disabled={!bookingCanModify}
                                    setDate={newDate => {
                                        const timeDiff = moment(
                                            values.custom_booking?.activity_end
                                        ).diff(values.custom_booking?.activity_start);
                                        setFieldValue(
                                            'custom_booking.activity_start',
                                            moment(newDate).format('YYYY-MM-DD HH:mm:ss')
                                        );
                                        setFieldValue(
                                            'custom_booking.activity_end',
                                            moment(newDate)
                                                .add(timeDiff)
                                                .format('YYYY-MM-DD HH:mm:ss')
                                        );
                                    }}
                                    enableTimePicker
                                    inputFormat="ddd MMM DD, YYYY [at] h:mm A"
                                />
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                disabled
                                label="Activity End Date & Time"
                                fullWidth
                                required
                                type="text"
                                value={moment(values.custom_booking?.activity_end).format(
                                    'ddd MMM DD, YYYY [at] h:mm A'
                                )}
                            />
                        </Grid>
                        {bookingCanModify && (
                            <Grid container item alignItems="center">
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        setFieldValue('custom_booking', null);
                                        setFieldValue('custom_booking_id', null);
                                    }}
                                >
                                    Remove Custom Booking
                                </Button>
                            </Grid>
                        )}
                    </>
                )}
            </FormSection>
        </>
    );
}
